import "./LogoSection.scss";

interface LogoSectionProps {
  variant: "arvato" | "platbricks";
}

const LogoSection = (props: LogoSectionProps) => {
  const { variant } = props;

  const logoPath = () => {
    switch (variant) {
      case "arvato":
        return require("../../assets/images/Arvato_Systems_Logo.png");
      case "platbricks":
        return require("../../assets/images/Platbricks_Logo.png");
    }
  };

  return (
    <div className="logo-section" data-testid="logo-section">
      <img src={logoPath()} alt="Arvato Logo" />
    </div>
  );
};
export default LogoSection;
